import { Flame, Zap, Rocket } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function DetailGrid({ productId }) {
  console.log(productId, "productId in DetailGrid")
  const [modules, setModules] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    async function loadModules() {
      try {
        const file = await import(`../data/product${productId}-modules.json`);
        setModules(file.default || file);
      } catch (err) {
        setModules(null);
      }
    }
    if (productId) {
      loadModules();
    }
  }, [productId]);

  if (!modules || !modules.features) {
    return null;
  }
  console.log(modules, "modules in DetailGrid")
  const projects = [
    {
      id: 1,
      title: (modules && t(`productModules.product${modules?.productId || productId}.features.3.title`)) || (modules && modules.features[3] && modules.features[3].title),
      description: (modules && t(`productModules.product${modules?.productId || productId}.features.3.explanation`)) || (modules && modules.features[3] && modules.features[3].explanation),
      image: modules&& modules.features[3] && modules.features[3].image,
      imagePosition: 'right', // text left, image right
    },
    {
      id: 2,
      title: (modules && t(`productModules.product${modules?.productId || productId}.features.4.title`)) || (modules && modules.features[4] && modules.features[4].title),
      description: (modules && t(`productModules.product${modules?.productId || productId}.features.4.explanation`)) || (modules && modules.features[4] && modules.features[4].explanation),
      image: modules&& modules.features[4] && modules.features[4].image,
      imagePosition: 'left', // image left, text right
    },
    {
      id: 3,
      title: (modules && t(`productModules.product${modules?.productId || productId}.features.5.title`)) || (modules && modules.features[5] && modules.features[5].title),
      description: (modules && t(`productModules.product${modules?.productId || productId}.features.5.explanation`)) || (modules && modules.features[5] && modules.features[5].explanation),
      image: modules&& modules.features[5] && modules.features[5].image,
      imagePosition: 'right', // text left, image right
    },
  ];
  return (
    <div className="min-h-screen bg-[#0a0a1a] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">

        {/* Main Feature Card - Writing Tool */}
        <div className="bg-gradient-to-br from-[#1a1a3e] to-[#0f0f2a] rounded-2xl p-8 mb-6 border border-gray-800">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="flex items-center gap-2 text-orange-500 text-sm font-medium mb-4">
                <Flame className="w-4 h-4" />
                {t('badges.hot')}
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
              {projects[0].title}
              </h2>
              <p className="text-gray-400 mb-6">
                {projects[0].description}
              </p>
            </div>
            <div className="relative">
              <div className="bg-white rounded-lg shadow-2xl p-4 transform hover:scale-[1.02] transition-transform">
                <div className="aspect-[4/3] bg-gray-100 rounded flex items-center justify-center">
                  <div className="text-gray-400 text-center">
                    <img src={projects[0].image} alt={projects[0].title} className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Two Column Features */}
        <div className="grid md:grid-cols-2 gap-6">
          {/* FlowAI Chat Feature */}
          <div className="bg-gradient-to-br from-[#1a1a3e] to-[#0f0f2a] rounded-2xl p-8 border border-gray-800">
            <div className="flex items-center gap-2 text-orange-500 text-sm font-medium mb-4">
              <Zap className="w-4 h-4" />
              {t('badges.popular')}
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              {projects[1].title}
            </h3>
            <p className="text-gray-400 mb-6">
              {projects[1].description}
            </p>
            <div className="bg-white rounded-lg shadow-xl p-4 mt-6">
              <div className="aspect-[4/3] bg-gray-100 rounded flex items-center justify-center">
                <div className="text-gray-400 text-center">
                  <img src={projects[1].image} alt={projects[1].title} className="w-full h-full object-cover" />
                </div>
              </div>
            </div>
          </div>

          {/* Video Creation Feature */}
          <div className="bg-gradient-to-br from-[#1a1a3e] to-[#0f0f2a] rounded-2xl p-8 border border-gray-800">
            <div className="flex items-center gap-2 text-orange-500 text-sm font-medium mb-4">
              <Rocket className="w-4 h-4" />
              {t('badges.featured')}
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              {projects[2].title}
            </h3>
            <p className="text-gray-400 mb-6">
              {projects[2].description}
            </p>
            <div className="bg-white rounded-lg shadow-xl p-4 mt-6">
              <div className="aspect-[4/3] bg-gray-100 rounded flex items-center justify-center">
                <div className="text-gray-400 text-center">
                  <img src={projects[2].image} alt={projects[2].title} className="w-full h-full object-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailGrid;
